import React from "react";
import AppNavbar from "@/components/common/AppNavbar";
import { Toaster } from "@/components/ui/toaster";

type AppLayoutProps = {
  children: React.ReactNode;
  title?: string;
  rightContent?: React.ReactNode;
  subHeaderContent?: React.ReactNode;
  fullWidth?: boolean;
};

const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  title,
  rightContent,
  subHeaderContent,
  fullWidth = false,
}) => {
  // Note: User status checking is now handled by UserStatusGuard component
  return (
    <div className='flex flex-col h-screen bg-background text-foreground'>
      {/* Fixed Navbar */}
      <AppNavbar title={title} rightContent={rightContent} />

      {subHeaderContent && (
        <div
          className='
            w-full
            min-h-[60px]
            h-auto
            sm:px-10
            py-2
            sm:py-6
            md:py-8
            lg:py-4
            flex items-center
            gap-10
            border-b
            sticky
            top-[65px]  
            z-10
            bg-white
            dark:bg-[#061A23]
            border-b-[#E5E5E5]
            dark:border-b-[#005C89]
          '>
          {subHeaderContent}
        </div>
      )}

      {/* Scrollable Main Content with padding for fixed navbar */}
      <main className='flex-1 overflow-y-auto overflow-x-hidden relative pt-[65px]'>
        <div className={fullWidth ? "h-full w-full" : "mx-auto px-4 py-4 md:px-[40px] md:py-4 h-full"}>
          {children}
        </div>
      </main>
      <Toaster />
    </div>
  );
};

export default AppLayout;
